import { interiorModules } from "../data/catalog";
import { interiorLayoutMasters } from "../data/expansion";

function cleanValue(value: string): string {
  return value
    .replace(/^[\s>*#-]+/, "")
    .replace(/\*\*/g, "")
    .replace(/^["'“”]+|["'“”]+$/g, "")
    .trim();
}

function readLineValue(response: string, labels: string[]): string {
  for (const line of response.split(/\r?\n/)) {
    for (const label of labels) {
      const match = line.match(new RegExp(`^\\s*(?:[-*]\\s*)?${label}\\s*:\\s*(.+)$`, "i"));
      if (match?.[1]) return cleanValue(match[1]);
    }
  }
  return "";
}

export function normalizePagePlanText(value: string): string {
  return value.replace(/\bHabit Evidence Tracker\b/gi, "Evidence Record");
}

function matchNamedIds(value: string, options: Array<{ id: string; name: string }>): string[] {
  if (!value) return [];
  const pieces = value
    .split(/[;,|]/)
    .map(cleanValue)
    .filter(Boolean);

  return pieces.flatMap((piece) => {
    const normalized = piece.toLowerCase();
    const legacyAliases: Record<string, string> = {
      "habit evidence tracker": "habit-tracker",
    };
    const aliasedId = legacyAliases[normalized];
    const match = options.find(
      (option) =>
        option.name.toLowerCase() === normalized ||
        option.id.toLowerCase() === normalized ||
        option.id === aliasedId,
    );
    return match ? [match.id] : [];
  });
}

export function extractTitleRecommendation(response: string): {
  title: string;
  subtitle: string;
} {
  return {
    title: readLineValue(response, ["Recommended title", "Title"]),
    subtitle: readLineValue(response, ["Recommended subtitle", "Subtitle"]),
  };
}

export function extractInteriorRecommendation(response: string): {
  layoutIds: string[];
  moduleIds: string[];
  sequenceNotes: string;
  backCoverCopy: string;
} {
  return {
    layoutIds: matchNamedIds(
      readLineValue(response, ["Paper Kingdom layouts"]),
      interiorLayoutMasters,
    ),
    moduleIds: matchNamedIds(
      readLineValue(response, ["Paper Kingdom page types"]),
      interiorModules,
    ),
    sequenceNotes: normalizePagePlanText(
      readLineValue(response, ["Paper Kingdom page flow"]),
    ),
    backCoverCopy: readLineValue(response, [
      "Paper Kingdom back-cover text",
      "Paper Kingdom back cover text",
      "Back-cover text",
    ]),
  };
}
